import { useRef } from "react";
import { Quote, Star, ChevronLeft, ChevronRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { testimonialPhotoUrl } from "@/lib/api";

const Stars = ({ n, id }) => (
  <span className="flex gap-0.5" aria-label={`Rating ${n} dari 5`} data-testid={`testimonial-rating-${id}`}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`h-3.5 w-3.5 ${i <= n ? "fill-nanina-butter text-nanina-butter" : "text-nanina-line"}`} />)}
  </span>
);

const Card = ({ t, catName }) => (
  <figure className="snap-start shrink-0 w-[85%] sm:w-[calc(50%-6px)] lg:w-[calc(33.333%-8px)] rounded-3xl bg-white border border-nanina-line p-5 flex flex-col" data-testid={`testimonial-${t.id}`}>
    <div className="flex items-center justify-between">
      <Quote className="h-5 w-5 text-nanina-peach" />
      {t.rating ? <Stars n={t.rating} id={t.id} /> : null}
    </div>
    <blockquote className="mt-2 text-sm text-nanina-ink leading-relaxed flex-1">{t.text}</blockquote>
    <figcaption className="mt-3 flex items-center gap-2 text-xs font-semibold text-nanina-green">
      {t.has_photo && <img src={testimonialPhotoUrl(t)} alt={t.name || "Pelanggan"} loading="lazy" className="h-9 w-9 rounded-full object-cover" data-testid={`testimonial-photo-${t.id}`} />}
      <span>{[t.name, catName[t.category_id]].filter(Boolean).join(" · ") || "Keluarga Nanina Care"}</span>
    </figcaption>
  </figure>
);

export const Testimonials = () => {
  const { site } = useSite();
  const track = useRef(null);
  if (!site.testimonials.length) return null;
  const catName = Object.fromEntries(site.categories.map((c) => [c.id, c.name]));
  const scroll = (d) => track.current?.scrollBy({ left: d * track.current.clientWidth * 0.85, behavior: "smooth" });
  const navBtn = "h-9 w-9 grid place-items-center rounded-full border border-nanina-line bg-white text-nanina-green hover:bg-nanina-skysoft transition-colors";
  return (
    <section id="testimoni" className="pb-12 sm:pb-16" data-testid="testimonials-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="flex items-end justify-between gap-3">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-nanina-fresh">Testimoni</p>
            <h2 className="mt-1 text-2xl sm:text-3xl font-extrabold tracking-tight text-nanina-green">Cerita dari Ayah & Bunda</h2>
          </div>
          {site.testimonials.length > 1 && (
            <div className="flex gap-2">
              <button onClick={() => scroll(-1)} className={navBtn} aria-label="Sebelumnya" data-testid="testimonials-prev"><ChevronLeft className="h-4 w-4" /></button>
              <button onClick={() => scroll(1)} className={navBtn} aria-label="Berikutnya" data-testid="testimonials-next"><ChevronRight className="h-4 w-4" /></button>
            </div>
          )}
        </div>
        <div ref={track} className="mt-5 flex gap-3 overflow-x-auto nn-scroll-x snap-x snap-mandatory pb-1" data-testid="testimonials-track">
          {site.testimonials.map((t) => <Card key={t.id} t={t} catName={catName} />)}
        </div>
      </div>
    </section>
  );
};
